var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex",attrs:{"id":"tooltip"}},[(_vm.$slots.default)?[_vm._t("default")]:[_c('span',{staticClass:"tooltip"},[_vm._v("i")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }